module.exports = __webpack_public_path__ + "static/media/YMCA c. 1920.67fd23c4.jpeg";